import { useEffect, useState } from "react";
import { GET_SUBURB_LIST } from "../api/constants";

const useSuburbs = () => {
  const [suburbs, setSuburbs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSuburbs = async () => {
      try {
        const response = await fetch(GET_SUBURB_LIST);
        const data = await response.json();

        // ✅ tolerate different API shapes
        if (Array.isArray(data?.data)) {
          setSuburbs(data.data);
        } else if (Array.isArray(data)) {
          setSuburbs(data);
        } else {
          setSuburbs([]);
        }
      } catch (err) {
        console.error("Error fetching suburbs:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSuburbs();
  }, []);

  return { suburbs, loading, error };
};


export default useSuburbs;
